import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer-service.qa.onyxcentersource.com',
  hostname: 'pioneer.qa.onyxcentersource.com',
  portalUrl: 'https://portal.qa.onyxcentersource.com',

  allowApiDocs: true
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/environments/environment.qa.ts